import { useEffect, useState } from 'react';
import { ABTest, ABTestingKeys, LandingPageScenarioType } from '../utils/ABTesting';

interface Scenarios {
  landingPage: LandingPageScenarioType;
}

const initialScenarios: Scenarios = {
  landingPage: 'default'
};

export function useABTest() {
  const [scenarios, setScenarios] = useState(initialScenarios);

  useEffect(() => {
    let newScenarios = { ...scenarios };

    newScenarios.landingPage = ABTest.getScenario(ABTestingKeys.LandingPage);

    setScenarios(newScenarios);
  }, []);

  return scenarios;
}
